<template>
  <div>
    <v-row class="mt-4">
      <v-col cols="6">
        <div class="header-content">Custom field details</div>
        <slot name='body'></slot>
      </v-col>
      <v-col cols="1" />
      <v-col cols="5">
        <div class="header-content">Custom field preview</div>

        <fieldPreview
          tabindex='1'
          :itemType='itemType'
          :preloadedItem='preloadedItem'/>

      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'customFieldsSettingComponent',
  props: {
    itemType: {
      type: String,
      required: true,
      default: ''
    },
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null,
          customFieldArrayValues: []
        }
      }
    }
  },
  components: {
    fieldPreview: () => import('@/components/customFields/commonMixins/fieldPreview')
  }
}
</script>

<style lang='scss'>
  .setting-tigle {
    color: #7d7d7d;
    font-weight: 600;
    font-size: 1.3rem;
  }
</style>
